import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {MessageAdminRole} from "@domain/admin/bibliotheque/notification/message-admin-role";
import {TypeProfil} from "@domain/user/user";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService} from "@services/admin/bibliotheque/notification.service";
import {ToastrService} from "ngx-toastr";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {ActivatedRoute} from "@angular/router";
import {handleResult} from "@share/utils/handle-result";
import {filter} from "rxjs/operators";

/**
 * Composant d'affichage des items de la liste des rôles
 *
 * @author Lionel Gimenez
 * @date 26/03/2026
 */
@Component({
    host: {'data-test-id': 'role-item'},
    selector: 'role-item',
    templateUrl: './role-item.component.html'
})
export class RoleItemComponent extends ListViewItem<MessageAdminRole> {
    /** Déclaration pour le template */
    readonly TypeProfil = TypeProfil;

    /**
     * Constructeur
     *
     * @param translateService le moteur de traduction
     * @param notificationService le service de notification
     * @param toastrService le service de toast
     * @param confirmService le service de confirmation
     * @param activatedRoute la route active
     */
    constructor(
        public translateService: TranslateService,
        private notificationService: NotificationService,
        private toastrService: ToastrService,
        private confirmService: ConfirmService,
        private activatedRoute: ActivatedRoute
    ) {
        super();
    }

    /**
     * Handler du delete
     */
    onDelete(): void {
        //Affichage de la confirmation de suppression
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe({
                next: () => {
                    //Récupération de l'id du message
                    const idMessage: number = this.activatedRoute.snapshot.params.idAccueil;

                    //Suppression du rôle
                    this.notificationService.deleteRoles(idMessage, [this.data.idRole])
                        .pipe(handleResult(this.translateService,this.toastrService,'global.success.suppression','global.errors.suppression'))
                        .subscribe(() => this.liste.refresh());
                }
            });
    }
}
